import { render, staticRenderFns } from "./PolicyInfo.vue?vue&type=template&id=6b58ac76"
import script from "./PolicyInfo.vue?vue&type=script&lang=ts"
export * from "./PolicyInfo.vue?vue&type=script&lang=ts"
import style0 from "./PolicyInfo.vue?vue&type=style&index=0&id=6b58ac76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports